/**
 * Client-side resize + JPEG compress for CMS uploads (Firestore doc size / bandwidth).
 */
export function compressImage(file, maxDim = 1400, targetBytes = 750_000) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (ev) => {
      const img = new Image();
      img.src = ev.target.result;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        let w = img.width;
        let h = img.height;
        if (w > maxDim || h > maxDim) {
          if (w > h) {
            h = Math.round((h * maxDim) / w);
            w = maxDim;
          } else {
            w = Math.round((w * maxDim) / h);
            h = maxDim;
          }
        }
        canvas.width = w;
        canvas.height = h;
        canvas.getContext("2d").drawImage(img, 0, 0, w, h);

        let quality = 0.82;
        let result = canvas.toDataURL("image/jpeg", quality);
        while (result.length > targetBytes && quality > 0.18) {
          quality = Math.round((quality - 0.1) * 100) / 100;
          result = canvas.toDataURL("image/jpeg", quality);
        }
        if (result.length > targetBytes) {
          canvas.width = Math.round(w / 2);
          canvas.height = Math.round(h / 2);
          canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
          result = canvas.toDataURL("image/jpeg", 0.72);
        }
        resolve(result);
      };
      img.onerror = reject;
    };
    reader.onerror = reject;
  });
}
